import { reactive, VNodeChild } from "vue"

export type ToastType = "success" | "error" | "info" | "warning" | "ghost"

export type ToastContent = string | (() => VNodeChild)

export interface ToastItem {
  id: number | string
  type: ToastType
  duration: number
  content: ToastContent
}

const state = reactive({
  toasts: [] as ToastItem[],
})

let id = 0

function useToast() {
  const show = ({
    type = "info",
    duration = 3000,
    uuid = id,
    content,
  }: {
    type?: ToastType
    duration?: number
    content: ToastContent
    uuid?: string | number
  }) => {
    const toast: ToastItem = {
      id: uuid || ++id,
      type,
      duration,
      content,
    }

    state.toasts.push(toast)

    setTimeout(() => {
      remove(toast.id)
    }, duration)
  }

  const remove = (toastId: number | string) => {
    const index = state.toasts.findIndex((t) => t.id === toastId)

    if (index !== -1) {
      state.toasts.splice(index, 1)
    }
  }

  const success = (message: string, duration?: number) => {
    show({ content: message, type: "success", duration })
  }

  const error = (message: string, duration?: number) => {
    show({ content: message, type: "error", duration })
  }

  const info = (message: string, duration?: number) => {
    show({ content: message, type: "info", duration })
  }

  const warning = (message: string, duration?: number) => {
    show({ content: message, type: "warning", duration })
  }

  return {
    toasts: state.toasts,
    show,
    success,
    error,
    info,
    warning,
    remove,
  }
}

export const toast = useToast()
